import { Typography } from "@mui/material";
import { ContentWrapper } from "@src/components";
import { FormattedDateWidthDateTime } from "@src/components/FormattedDateWithDateTime";
import { type GQLCameraAdminQuery } from "@src/graphql.generated";
import { type ReactElement } from "react";
import { FormattedMessage, useIntl } from "react-intl";

// eslint-disable-next-line @comet/no-private-sibling-import
import { StyledTypography } from "./SubscriptionInformation.sc";

interface InformationProps {
    date: Date | null;
}

const Information = ({ date }: InformationProps): ReactElement => {
    const intl = useIntl();

    if (date) {
        return (
            <StyledTypography>
                <FormattedMessage id="reviermanager.camera.image.lastReceived.information" defaultMessage="Letztes Bild übertragen am:" />{" "}
                <FormattedDateWidthDateTime
                    variant="bold"
                    value={date}
                    separator={` ${intl.formatMessage({
                        id: "reviermanager.camera.image.lastReceived.separator",
                        defaultMessage: "um",
                    })} `}
                    endAdornment={` ${intl.formatMessage({
                        id: "reviermanager.camera.image.lastReceived.endAdornment",
                        defaultMessage: "Uhr",
                    })} `}
                />
            </StyledTypography>
        );
    }

    return (
        <Typography>
            <FormattedMessage id="reviermanager.camera.image.lastReceived.empty" defaultMessage="Noch kein Bild übertragen" />
        </Typography>
    );
};

export const LastReceivedImageInformation = ({ cameraAdmin }: GQLCameraAdminQuery): ReactElement => {
    const intl = useIntl();

    return (
        <ContentWrapper title={intl.formatMessage({ id: "reviermanager.camera.image.lastReceived.title", defaultMessage: "Bilder" })}>
            <Information date={cameraAdmin.lastReceivedImageAt} />
        </ContentWrapper>
    );
};
